import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Input, Button, Card } from 'antd';
import store from '../../reducers/store';
import updateUserProfile from '../../userFunctions/updateUserProfile';
import '../../combinedStyles';
import '../../fontello/css/fontello.css';
import filterService from '../../services/filterService';
import userService from '../../services/userService';

class PlayerToken extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playerObj: this.props.playerObj,
      active: this.props.active,
      type: this.props.type,
      hidden: this.props.hidden,
      tracked: this.props.tracked,
    };
  }

  handleMainIcon() {
    var trackedPlayers = this.props.trackedPlayers;
    var hiddenPlayers = this.props.hiddenPlayers;

    if (this.props.type == 'searchPlayers') {
      if (this.state.tracked) {
        return;
      }
      if (!this.state.tracked) {
        const trackedPlayerList = this.props.trackedPlayers;
        trackedPlayerList.push(this.props.playerObj);
        filterService.editZmailTracked(trackedPlayerList, this.props.displayedUser).then(() => {
          store.dispatch({ type: 'UPDATE_TRACKED_PLAYERS', trackedPlayers: trackedPlayerList });
          // userService.getUser(this.props.displayedUser.id)
        });
        // filterService.unHidePlayer(this.props.playerObj.ild)
        this.setState({
          tracked: true,
          hidden: false,
        });
      }
    } else if (this.props.type == 'trackedPlayers' && this.state.tracked) {
      const trackedPlayerList = this.props.trackedPlayers;
      const index = trackedPlayerList.findIndex((trackedPlayer) => {
        return trackedPlayer.id === this.props.playerObj.id;
      });
      trackedPlayerList.splice(index, 1);
      filterService.editZmailTracked(trackedPlayerList, this.props.displayedUser).then(() => {
        store.dispatch({ type: 'UPDATE_TRACKED_PLAYERS', trackedPlayers: trackedPlayerList });
        // userService.getUser(this.props.displayedUser.id)
      });

      // var index = trackedPlayers.indexOf(this.props.playerObj.id.S)
      // trackedPlayers.splice(index, 1)

      // updateUserProfile("TrackedPlayers", trackedPlayers)
      // store.dispatch({ type: 'UPDATE_TRACKED_PLAYERS', TrackedPlayers: trackedPlayers })

      this.setState({
        active: false,
        tracked: false,
      });

      this.props.playerSelected();
    } else if (this.props.type == 'hiddenPlayers' && this.state.hidden) {
      this.removeHiddenPlayer();
    }
  }

  handleHideOrUnhide() {
    var hiddenPlayers = this.props.hiddenPlayers;
    var trackedPlayers = this.props.trackedPlayers;

    if (this.props.type == 'searchPlayers') {
      let playerAlreadyHidden = hiddenPlayers.indexOf(this.props.playerObj.id.S) > -1;
      if (playerAlreadyHidden) {
        return;
      } else {
        hiddenPlayers.push(this.props.playerObj.id.S);
        updateUserProfile('hiddenPlayers', hiddenPlayers);
        store.dispatch({ type: 'UPDATE_HIDDEN_PLAYERS', hiddenPlayers: hiddenPlayers });

        var index = trackedPlayers.indexOf(this.props.playerObj.id.S);
        if (index > -1) {
          trackedPlayers.splice(index, 1);
        }

        updateUserProfile('TrackedPlayers', trackedPlayers);
        store.dispatch({ type: 'UPDATE_TRACKED_PLAYERS', TrackedPlayers: trackedPlayers });

        this.setState({
          hidden: true,
          tracked: false,
        });
      }
    } else if (this.props.type == 'hiddenPlayers') {
      this.removeHiddenPlayer(hiddenPlayers);
    }
  }

  removeHiddenPlayer() {
    var hiddenPlayers = this.props.hiddenPlayers;
    var index = hiddenPlayers.indexOf(this.props.playerObj.id.S);
    hiddenPlayers.splice(index, 1);

    updateUserProfile('hiddenPlayers', hiddenPlayers);
    store.dispatch({ type: 'UPDATE_HIDDEN_PLAYERS', hiddenPlayers: hiddenPlayers });

    this.setState({
      active: false,
      hidden: true,
    });

    this.props.playerSelected();
  }

  addDefaultSrc(event) {
    event.target.src = 'https://s3media.247sports.com/Uploads/Player/0/4_0.jpg';
  }

  render() {
    // console.log(this.props)
    if (this.props.playerObj && this.state.active) {
      const location = this.props.playerObj.location;
      const displayPostion =
        this.props.playerObj.positions.length > 0 ? this.props.playerObj.positions[0].name : '';
      const displayLocation = this.props.playerObj.location
        ? this.props.playerObj.location.label
        : '';

      //remove school name from location
      // var location = this.props.playerObj.location.S;
      // var index = location.indexOf('(');
      // if (index > -1) {
      //   location =  location.slice(0, index)
      // }
      var playerImage =
        this.props.playerObj['image_url'] ||
        'https://s3media.247sports.com/Uploads/Player/0/4_0.jpg';

      //only show icon in search players

      var mainIcon = (() => {
        var icon;
        var style = { fontSize: 19, color: '#474747' };
        if (this.state.type == 'searchPlayers') {
          if (this.state.tracked) {
            icon = 'check-circle';
          } else {
            if (this.state.hidden) style.color = '#d3d3d3';
            icon = 'plus';
          }
        } else {
          icon = 'close';
        }
        return (
          <Icon
            className='tokenIcon'
            style={style}
            type={icon}
            onClick={this.handleMainIcon.bind(this)}
          />
        );
      })();

      var hideIcon = (() => {
        var className;
        if (this.state.type == 'searchPlayers') {
          if (this.state.hidden) {
            className = 'icon-eye-off';
          } else {
            className = 'icon-eye';
          }
          return (
            <i
              onClick={this.handleHideOrUnhide.bind(this)}
              aria-hidden='true'
              className={className + ' fa-lg tokenIcon'}></i>
          );
        } else {
          return null;
        }
      })();
      return (
        <Card className='playerToken' bodyStyle={{ padding: 3 }} style={{ width: 210, height: 80 }}>
          <div>
            {mainIcon}
            {/* {hideIcon}         */}
          </div>
          <div>
            <img
              src={playerImage}
              alt={this.props.playerObj['name']}
              className='playerTokenImg'
              onError={this.addDefaultSrc}
            />
          </div>
          <div className='tokenInfo'>
            <p className='nameAttr'>{this.props.playerObj.name}</p>
            <p className='positionAttr'>{displayPostion + ' | ' + this.props.playerObj.year}</p>
            <p className='locationAttr'>{displayLocation}</p>
          </div>
        </Card>
      );
    } else {
      return null;
    }
  }
}

function mapStoreToProps(storeState) {
  return {
    trackedPlayers: storeState.main.trackedPlayers,
    hiddenPlayers: storeState.lists.hiddenPlayers,
    displayedUser: storeState.main.displayedUser,
  };
}

export default connect(mapStoreToProps)(PlayerToken);



// WEBPACK FOOTER //
// ./src/components/trackedProspects/PlayerToken.js